var React = require('react');

function FacebookLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z","stroke":"#1F1F1F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.5 5.50001H9.50001C9.3028 5.49919 9.10737 5.53742 8.92501 5.61251C8.74265 5.6876 8.57696 5.79806 8.43751 5.93751C8.29806 6.07696 8.1876 6.24265 8.11251 6.42501C8.03742 6.60737 7.99919 6.8028 8.00001 7.00001V14","stroke":"#1F1F1F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6 9H10","stroke":"#1F1F1F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

FacebookLogo.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = FacebookLogo;

FacebookLogo.default = FacebookLogo;
